import { useState } from 'react';
import { MinusCircleIcon, PlusCircleIcon } from '@heroicons/react/24/outline';
import Button from './Button';

type AccordionProps = {
  title: string | React.ReactNode;
  children: React.ReactNode;
  isOpened?: boolean;
};

const Accordion = ({ title, children, isOpened }: AccordionProps) => {
  const [isOpen, setIsOpen] = useState(!!isOpened);

  return (
    <div className="text-sm mb-2">
      <div
        className="flex items-center justify-between bg-slate-300 p-2"
        onClick={() => setIsOpen(!isOpen)}
      >
        <p>{title}</p>
        <Button
          className="text-slate-500"
          icon={
            isOpen ? (
              <MinusCircleIcon className="h-5 w-5" />
            ) : (
              <PlusCircleIcon className="h-5 w-5" />
            )
          }
        />
      </div>
      <div className={!isOpen ? 'hidden' : ''}>{children}</div>
    </div>
  );
};

export default Accordion;
